<template>
	<div class="breadcrumbs">
		<div class="breadcrumb__parent">
			<router-link
				v-for="(path, i) in articlePath"
				:key="i"
				:to="path.link"
				>
				{{ path.name }}
			</router-link>
		</div>
		<span class="breadcrumb__title">{{article.title}}</span>
	</div>
</template>

<script>
export default {
	name: "ArticleBreadCrumbs",
	props: ["article"],
	computed: {
		articlePath: function () {
			return this.$store.getters.articlePath(this.article.id);
		},
	}
};
</script>

<style scoped>

.breadcrumbs {
	display: flex;
	align-items: center;
	padding: 1em 2em;
	box-shadow: 0 0 1em 0 rgb(0, 0, 0, 0.1);
}

.breadcrumb__parent {
	display: flex;
	color: var(--clr-accent-primary);
}

.breadcrumb__parent a:hover {
	cursor: pointer;
	color: var(--clr-accent-primary-shade-4);
	text-decoration: none;
}

.breadcrumb__parent a {
	display: flex;
	align-items: center;
}

.breadcrumb__parent a::after {
	content: '\f054';
	width: 1.4rem;
	height: auto;
	font-family: "Font Awesome 6 Pro";
	font-size: 0.8em;
	margin-left: 1.2em;
	margin-right: 0em;
}

.breadcrumb__parent a:hover::after {

}

.breadcrumb__title {
	color: var(--textGrey);
}

</style>